import { Widget } from '../../../apiService';
import type { TeaserHeaderInfo } from './TeaserVideoWidget/TeaserVideo';
import WidgetItem from './WidgetItem';

export { WidgetWrapper } from './WidgetWrapper';

type WidgetManagerProps = {
  widgets: Widget[];
  headerInfo?: TeaserHeaderInfo;
  serverTime?: string;
};

export default function WidgetManager({ widgets, headerInfo, serverTime }: WidgetManagerProps) {
  // Pages that pass a non-compact `headerInfo` render their title above the widgets, so the first
  // widget is not at the top of the page. Without `headerInfo` (homepage) nothing renders above them.
  const pageHasTitle = !!headerInfo && !headerInfo.compact;
  // `afterSlider` marks the row under the slider, whose spacing the slider's bottom margin sets alone.
  const sliderIndex = widgets?.findIndex((w) => w.type === 'main_slider') ?? -1;
  // `afterTeaser` marks the widget directly after the teaser. The live widget uses it to pull itself
  // up onto the teaser (LiveCardList); the wrapper uses it to out-stack the teaser so that overlap
  // isn't clipped. Other widget types ignore it and just flow cleanly below the teaser.
  const teaserIndex = widgets?.findIndex((w) => (w.content_category_type || w.type) === 'teaser_video') ?? -1;
  // First widget under the homepage slider (or the first widget on pages without a slider).
  // Only means "load first-row images eagerly" — not fetchpriority=high.
  const firstWidgetIndex = widgets?.findIndex((w) => w.type !== 'main_slider') ?? -1;
  return (
    <>
      {widgets && widgets.map((w, i) => (
        <WidgetItem
          key={w.id}
          widget={w}
          // The compact header (see CompactHeader) sits on the widget at the top of the page. A teaser
          // further down renders as on a non-compact page, without going under the header.
          headerInfo={i === 0 ? headerInfo : undefined}
          afterTeaser={teaserIndex !== -1 && i === teaserIndex + 1}
          afterSlider={sliderIndex !== -1 && i === sliderIndex + 1}
          atPageTop={i === 0 && !pageHasTitle}
          eager={i === firstWidgetIndex}
          serverTime={serverTime}
        />
      ))}
    </>
  );
}
